import React from 'react';
import './date-range-selector.scss';
import moment from 'moment';
import { View, Text } from '../../common';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

interface DateRangeSelectorProps {
  dateState: {
    startDate: Date;
    endDate: Date;
    key: string;
  }[];
  onDateChange: (ranges: any) => void;
  dateSelectionMode?: 'date' | 'dateRange' | undefined;
}

export const DateRangeSelector: React.FC<DateRangeSelectorProps> = ({
  dateState,
  onDateChange,
  dateSelectionMode = 'dateRange',
}) => {
  return (
    <div className="date-range-selector-container">
      <View className="date-range-container">
        {[
          moment(dateState[0].startDate).format('MMMM DD, YYYY'),
          '-',
          moment(dateState[0].endDate).format('MMMM DD, YYYY'),
        ].map((item, index) => (
          <Text key={index} className="date-range-container-text font-medium">
            {item}
          </Text>
        ))}
      </View>

      <DateRange
        editableDateInputs={true}
        onChange={onDateChange}
        moveRangeOnFirstSelection={false}
        ranges={dateState}
        direction="vertical"
        scroll={{ enabled: true }}
        showMonthArrow={false}
        showMonthAndYearPickers={false}
        rangeColors={['#000000', '#DCDFE4']}
        showDateDisplay={false}
        displayMode={dateSelectionMode}
      />
    </div>
  );
};
